const THERE_WAS_AN_ERROR = 'There was an error';
export const TEACHER_ASSISTANT = {
  teacherAssistantErrorMessage: `${THERE_WAS_AN_ERROR} fetching the details of teacher assistant`,
  joinSplitCostErrorMessage: `${THERE_WAS_AN_ERROR} joining to the session`,
  joinSplitCostSuccessMessage: 'You have successfully joined',
};
